module.exports = __webpack_public_path__ + "static/media/calendar.18db1809.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calendar.svg
// module id = 910
// module chunks = 33